import React from "react";
import { graphql, useFragment } from "react-relay";
import { AHSeparator, Box } from "arkh";
import { WidgetTeamScheduleContentSectionHeader } from "./WidgetTeamScheduleContentSectionHeader";
import { WidgetTeamScheduleContentBaseProps } from "./WidgetTeamScheduleContentBaseProps";
import { WidgetTeamScheduleContentList } from "./WidgetTeamScheduleContentList";
import { WidgetTeamScheduleContentSummary_WidgetTeamScheduleContentSummary$key } from "./__generated__/WidgetTeamScheduleContentSummary_WidgetTeamScheduleContentSummary.graphql";
import { useNowIndexes } from "./useNowIndexes";

export function WidgetTeamScheduleContentSummary(
  props: WidgetTeamScheduleContentBaseProps & {
    content: WidgetTeamScheduleContentSummary_WidgetTeamScheduleContentSummary$key;
  }
) {
  const content = useFragment(
    graphql`
      fragment WidgetTeamScheduleContentSummary_WidgetTeamScheduleContentSummary on WidgetTeamScheduleContentSummary {
        dailyTeamSchedule {
          id
          ...WidgetTeamScheduleContentList_teamSchedule
          ...WidgetTeamScheduleContentSectionHeader_teamSchedule
          events(includeInlineRoutines: true) {
            id
            ...useNowIndexes_teamScheduleEventOccasion
          }
        }
        weeklyTeamSchedule {
          id
          ...WidgetTeamScheduleContentSectionHeader_teamSchedule
          events(includeInlineRoutines: true) {
            id
          }
        }
        monthlyTeamSchedule {
          id
          ...WidgetTeamScheduleContentSectionHeader_teamSchedule
          events(includeInlineRoutines: true) {
            id
          }
        }
      }
    `,
    props.content
  );

  const [nowIndexes, scrollIndex] = useNowIndexes({
    eventKey: content.dailyTeamSchedule?.events ?? [],
    now: props.now,
  });

  return (
    <Box style={{ flex: 1 }}>
      <Box>
        {content.monthlyTeamSchedule.events.length > 0 ? (
          <WidgetTeamScheduleContentSectionHeader
            tint={props.tint}
            teamSchedule={content.monthlyTeamSchedule}
          />
        ) : null}
        {content.weeklyTeamSchedule.events.length > 0 ? (
          <WidgetTeamScheduleContentSectionHeader
            tint={props.tint}
            teamSchedule={content.weeklyTeamSchedule}
          />
        ) : null}
        {content.dailyTeamSchedule.events.length > 0 ? (
          <WidgetTeamScheduleContentSectionHeader
            tint={props.tint}
            teamSchedule={content.dailyTeamSchedule}
          />
        ) : null}
      </Box>
      <AHSeparator spaceTop="xsmall" />
      <WidgetTeamScheduleContentList
        tint={props.tint}
        isDarkTint={props.isDarkTint}
        size={props.size}
        teamSchedule={content.dailyTeamSchedule}
        now={props.now}
        teamId={props.teamId}
        onPressRoutineOccasion={props.onPressRoutineOccasion}
        mode={props.mode}
        interactive={props.interactive}
        scrollIndex={scrollIndex}
        nowIndexes={nowIndexes}
        idiom={props.idiom}
        onScroll={props.onScroll}
        isFocused={props.isFocused}
      />
    </Box>
  );
}
